/* eslint-disable ember/no-classic-components */
import Component, { setComponentTemplate } from "@ember/component";
import { fn } from "@ember/helper";
import { computed, get } from "@ember/object";
import { reads } from "@ember/object/computed";
import { guidFor } from "@ember/object/internals";
import { tagName } from "@ember-decorators/component";
import { and } from "truth-helpers";
import DButton from "discourse/components/d-button";
import icon from "discourse/helpers/d-icon";
import { makeArray } from "discourse/lib/helpers";
import selectKitPropUtils from "select-kit/lib/select-kit-prop-utils";
import { precompileTemplate } from "@ember/template-compilation";
const SelectedName = dt7948.c(class SelectedName extends Component {
  name = null;
  value = null;
  headerTitle = null;
  headerLang = null;
  headerLabel = null;
  id = null;
  static {
    dt7948.g(this.prototype, "lang", [reads("headerLang")]);
  }
  #lang = (dt7948.i(this, "lang"), void 0);
  init() {
    super.init(...arguments);
    this.set("id", guidFor(this));
  }
  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    // we can't listen on `item.nameProperty` given it's variable
    this.setProperties({
      headerLabel: this.getProperty(this.item, "labelProperty"),
      headerTitle: this.getProperty(this.item, "titleProperty"),
      headerLang: this.getProperty(this.item, "langProperty"),
      name: this.getName(this.item),
      renderIcon: this.canDisplayIcon,
      value: this.item === this.selectKit.noneItem ? null : this.getValue(this.item)
    });
  }
  get canDisplayIcon() {
    return this.selectKit.options.shouldDisplayIcon ?? true;
  }
  static {
    dt7948.n(this.prototype, "canDisplayIcon", [computed("selectKit.options.shouldDisplayIcon")]);
  }
  get ariaLabel() {
    return this._safeProperty("ariaLabel", this.item) || this.sanitizedTitle;
  }
  // this might need a more advanced solution
  // but atm it's the only case we have to handle
  static {
    dt7948.n(this.prototype, "ariaLabel", [computed("item", "sanitizedTitle")]);
  }
  get sanitizedTitle() {
    return String(this.title).replace("&hellip;", "");
  }
  static {
    dt7948.n(this.prototype, "sanitizedTitle", [computed("title")]);
  }
  get title() {
    return this.headerTitle || this._safeProperty("title", this.item) || this.name || "";
  }
  static {
    dt7948.n(this.prototype, "title", [computed("headerTitle", "item")]);
  }
  get label() {
    return this.headerLabel || this._safeProperty("label", this.item) || this.title || this.name;
  }
  static {
    dt7948.n(this.prototype, "label", [computed("headerLabel", "title", "name")]);
  }
  get icons() {
    const _icon = makeArray(this._safeProperty("icon", this.item));
    const icons = makeArray(this._safeProperty("icons", this.item));
    return _icon.concat(icons).filter(Boolean);
  }
  static {
    dt7948.n(this.prototype, "icons", [computed("item.{icon,icons}")]);
  }
  _safeProperty(name, content) {
    if (!content) {
      return null;
    }
    return get(content, name);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.selectKit.options.showFullTitle}}\n      <div lang={{this.lang}} title={{this.title}} data-value={{this.value}} data-name={{this.name}} class=\"select-kit-selected-name selected-name choice\">\n        {{#if this.selectKit.options.formName}}\n          <input type=\"hidden\" name={{this.selectKit.options.formName}} value={{this.value}} />\n        {{/if}}\n\n        {{#if (and this.renderIcon this.item.icon)}}\n          {{icon this.item.icon}}\n        {{/if}}\n\n        <span class=\"name\">\n          {{this.label}}\n        </span>\n\n        {{#if this.shouldDisplayClearableButton}}\n          <DButton @icon=\"xmark\" @action={{fn this.selectKit.deselect this.item}} @ariaLabel=\"clear_input\" class=\"btn-clear\" />\n        {{/if}}\n      </div>\n    {{else}}\n      {{#if this.item.icon}}\n        <div lang={{this.lang}} class=\"select-kit-selected-name selected-name choice\">\n          {{icon this.item.icon}}\n        </div>\n      {{/if}}\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        and,
        icon,
        DButton,
        fn
      })
    }), this);
  }
}, [selectKitPropUtils, tagName("")]);
export default SelectedName;